import { useQuery } from "@tanstack/react-query";
import adminApiClient from "../../api/admin";

export type StudioUsersStats = {
  total: number;
  daily: { date: string; count: number }[];
};

export const useStudioUsersCount = () => {
  return useQuery<StudioUsersStats>({
    queryKey: ["studioUsersStats"],
    queryFn: () => adminApiClient.getStudioUsersStats(),
  });
};
